export default __webpack_public_path__ + "34e49bd75997b5a174b27f35399d0b91.png";